import React, { useRef, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FormikInput } from "./index";

const PhoneInputField = ({
    formikProps,
    disabled,
    disableComponent,
    onChange,
    ...props
}) => {
    const phoneInputRef = useRef(null);

    useEffect(() => {
        if (phoneInputRef.current) {
            const dropdownButton = phoneInputRef.current.dropdownContainerRef;

            if (dropdownButton) {
                const handleDropdownClick = () => {
                    const currentPhoneCode = formikProps.values.phoneCode || "+92";
                    formikProps.setFieldValue("phone", currentPhoneCode);
                    formikProps.setFieldValue("phoneNum", "");
                };

                dropdownButton.addEventListener("click", handleDropdownClick);
                return () => {
                    dropdownButton.removeEventListener("click", handleDropdownClick);
                };
            }
        }
    }, [formikProps]);

    // Call parent onChange when formik values change
    useEffect(() => {
        if (onChange) {
            onChange(formikProps.values);
        }
    }, [formikProps.values.phone, formikProps.values.phoneCode, formikProps.values.phoneNum, onChange]);

    return (
        <div>
            <div className="flex justify-between">
                <label htmlFor="phone" className="font-medium mb-1 text-sm text-[#0C1B3A]">
                    Phone
                </label>
            </div>
            {disabled ? (
                <FormikInput formikProps={formikProps} disabled={true} />
            ) : disableComponent ? (
                <PhoneInput
                    className="pl-2"
                    ref={phoneInputRef}
                    disabled={true}
                    inputProps={{
                        name: "ph",
                        required: true,
                        readOnly: true,
                    }}
                    value={formikProps.values.phone}
                    inputStyle={{
                        width: "100%",
                        backgroundColor: "#e9ecef",
                        color: "#6c757d",
                        border: "1px solid #ced4da",
                        cursor: "not-allowed",
                        height: "32px",
                        fontSize: "12px",
                    }}
                    buttonStyle={{
                        display: "none",
                    }}
                    placeholder=""
                    {...props}
                />
            ) : (
                <div>
                    <PhoneInput
                        ref={phoneInputRef}
                        country={"pk"}
                        inputProps={{
                            name: "phoneNum",
                            required: true,
                        }}
                        value={formikProps.values.phone}
                        onChange={(value, countryData) => {
                            const phoneCode = `+${countryData.dialCode}`;
                            const phoneNum = value.replace(countryData.dialCode, "").trim();
                            formikProps.setFieldValue("phoneCode", phoneCode);
                            formikProps.setFieldValue("phoneNum", phoneNum);
                            formikProps.setFieldValue("phone", value);
                        }}
                        inputStyle={{
                            width: "100%",
                            fontSize: "12px",
                            padding: "6px",
                            paddingLeft: "42px",
                            height: "34px",
                            borderRadius: "4px",
                            border: "1px solid #d1d5db",
                        }}
                        buttonStyle={{
                            border: "none",
                            backgroundColor: "transparent",
                            padding: "2px",
                            borderRadius: "4px 0 0 4px",
                        }}
                        containerStyle={{
                            maxWidth: "100%",
                        }}
                        dropdownStyle={{
                            maxHeight: "200px",
                            width: "260px",
                        }}
                        placeholder="3081234567"
                        {...props}
                    />
                    <style>{`
                        .react-tel-input .form-control {
                            padding-left: 42px !important;
                        }
                        .react-tel-input .flag-dropdown {
                            border-right: none !important;
                            background-color: transparent !important;
                        }
                        .react-tel-input .selected-flag:hover,
                        .react-tel-input .selected-flag:focus {
                            background-color: rgba(12, 27, 58, 0.05) !important;
                        }
                        .react-tel-input .country-list .country.highlight {
                            background-color: rgba(12, 27, 58, 0.1) !important;
                        }
                        .react-tel-input .country-list .country:hover {
                            background-color: rgba(12, 27, 58, 0.05) !important;
                        }
                    `}</style>
                </div>
            )}
            {formikProps.errors.phone && formikProps.touched.phone && (
                <div className="text-red-500 text-xs mt-1">
                    {formikProps.errors.phone}
                </div>
            )}
        </div>
    );
};

export default PhoneInputField;
